export default __webpack_public_path__ + "static/media/Instructions_3_2.406ba963.png";